// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1reWF","emails":"CreateEditClinics_emails__3ZxqQ","emailTagLabel":"CreateEditClinics_emailTagLabel__byGRN"};